import { FC } from 'react';

import { CellImage } from '../entries/entries.styles';
import { ImageData } from '../model';

export const Image: FC<ImageData> = ({ url, alt }) => {
    if (!url) {
        return null;
    }

    return <CellImage src={url} alt={alt} {...(!alt && { role: 'presentation' })} />;
};
